import video1 from "./videos/1.mp4";
import video2 from "./videos/2.mp4";
import video3 from "./videos/3.mp4";
import video4 from "./videos/4.mp4";

const credentials = [
	{
		name: "Aida",
		title: "Software Engineer",
		company: "Adobe Inc.",
		quote:
			"Chicago-Bakery never fails to impress with their delectable cakes! From classic flavors like chocolate and vanilla to innovative creations, every bite is a delight. Their cakes are always fresh, moist, and bursting with flavor. I highly recommend Chicago-Bakery for any occasion!",
		video: video1,
	},
	{
		name: "Aigerim",
		title: "React Developer",
		company: "Netflix Inc.",
		quote:
			"I recently ordered a cake from Chicago-Bakery for my daughter's birthday, and it was a huge hit! Not only was the design stunning, but the taste was out of this world. The moist layers, creamy frosting, and perfect balance of sweetness made it a memorable experience for everyone. Thank you, Chicago-Bakery, for making our celebration extra special!",
		video: video2,
	},
	{
		name: "Doolot",
		title: "Lowcode Developer",
		company: "Meta Platforms Inc.",
		quote:
			"Chicago-Bakery has become my go-to place for all things sweet! Their cakes are simply irresistible. Whether it's a simple afternoon treat or a grand celebration, their cakes never disappoint. Each slice is a heavenly indulgence, and I can't get enough of them. Chicago-Bakery definitely knows how to satisfy a sweet tooth!",
		video: video3,
	},
	{
		name: "Erkinai",
		title: "Frontend Developer",
		company: "Ulta Beauty Inc.",
		quote:
			"As a frequent customer of Chicago-Bakery, I can confidently say that they are the best in town! Their cakes are baked to perfection every time, with attention to detail and quality ingredients. Whether it's a birthday, wedding, or just a craving for something sweet, Chicago-Bakery has got you covered. I wouldn't trust anyone else with my cake needs!",
		video: video4,
	},
];

export default credentials;
